export const SPARKY_FRAMEWORK = 'sparky-framework'
export const OIDC_STORE_PREFIX = 'spk.oidc.'
export const TSG_ID_NONE = 'none'
export const SPARKY_ROOT_ELEMENT_TAG_NAME = 'sparky-root'
export const DEFAULT_ROOT_ELEMENT_ID = 'fawkes-root'
